export const getDateWithoutTimeInUtc = (date) => new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
